import userRoutes from './user'
import servicesRoutes from './services'
import administrationRoutes from './administration'

export default [
  ...servicesRoutes,
  ...userRoutes,
  ...administrationRoutes,
]
